import { DEFAULT_CRM_SYSTEM } from "@/features/crm_system/lib/_core/crmSystem/crmSystem.constants.gen";
import { QuestionFormSchemaType } from ".";

export const questionFormDefaultValues = {
    id: undefined,
    field_type: "",
    question: "",
    description: "",
    crm_system: DEFAULT_CRM_SYSTEM,
    selected_configuration: {
        parameter: [],
        conditionals: {
            enabled: false,
            where: {
                or: [{ and: [] }]
            },
        },
    },
    field_min: null,
    field_max: null,
    field_decimal_places: null,
    field_integer_places: null,
    field_step: null,
    field_options: [],
    field_placeholder: "",
    field_date_options: {},

    field_min_label: null,
    field_max_label: null,
    field_label: null,
    field_default_value: null,
} satisfies QuestionFormSchemaType;